export default {
  siteName: 'Saffe Dashboard',
  siteIcon: 'ion-flash',
  footerText: `Saffe © ${new Date().getFullYear()}. All rights reserved.`,
  enableAnimatedRoute: false,
  apiUrl: 'https://go.saffe.ai/v0/',
  siteUrl: 'https://go.saffe.ai/',
  cdnUrl: 'https://go.saffe.ai/cdn/',
  google: {
    analyticsKey: 'UA-xxxxxxxxx-1',
  },
  dashboard: '/dashboard',
};
